import { Component } from '@angular/core';
import { SecondaryPageComponent } from '../../secondary-page/secondary-page.component';

@Component({
  selector: 'app-food',
  standalone: true,
  imports: [],
  templateUrl: './food.component.html',
  styleUrl: './food.component.scss'
})
export class FoodComponent extends SecondaryPageComponent {

}
